"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = exports.TransactionOrderForkEvent = exports.TransactionForkEvent = exports.BlockForkEvent = exports.ForkEvent = void 0;

var _bytes = require("@ethersproject/bytes");

var _properties = require("@ethersproject/properties");

var _logger = require("@ethersproject/logger");

var _version = require("./_version");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var logger = new _logger.Logger(_version.version);
;
; //export type CallTransactionable = {
//    call(transaction: TransactionRequest): Promise<TransactionResponse>;
//};

var ForkEvent = /*#__PURE__*/function (_Description) {
  _inherits(ForkEvent, _Description);

  var _super = _createSuper(ForkEvent);

  function ForkEvent() {
    _classCallCheck(this, ForkEvent);

    return _super.apply(this, arguments);
  }

  _createClass(ForkEvent, null, [{
    key: "isForkEvent",
    value: function isForkEvent(value) {
      return !!(value && value._isForkEvent);
    }
  }]);

  return ForkEvent;
}(_properties.Description);

exports.ForkEvent = ForkEvent;

var BlockForkEvent = /*#__PURE__*/function (_ForkEvent) {
  _inherits(BlockForkEvent, _ForkEvent);

  var _super2 = _createSuper(BlockForkEvent);

  function BlockForkEvent(blockHash, expiry) {
    _classCallCheck(this, BlockForkEvent);

    if (!(0, _bytes.isHexString)(blockHash, 32)) {
      logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
    }

    return _super2.call(this, {
      _isForkEvent: true,
      _isBlockForkEvent: true,
      expiry: expiry || 0,
      blockHash: blockHash
    });
  }

  return BlockForkEvent;
}(ForkEvent);

exports.BlockForkEvent = BlockForkEvent;

var TransactionForkEvent = /*#__PURE__*/function (_ForkEvent2) {
  _inherits(TransactionForkEvent, _ForkEvent2);

  var _super3 = _createSuper(TransactionForkEvent);

  function TransactionForkEvent(hash, expiry) {
    _classCallCheck(this, TransactionForkEvent);

    if (!(0, _bytes.isHexString)(hash, 32)) {
      logger.throwArgumentError("invalid transaction hash", "hash", hash);
    }

    return _super3.call(this, {
      _isForkEvent: true,
      _isTransactionForkEvent: true,
      expiry: expiry || 0,
      hash: hash
    });
  }

  return TransactionForkEvent;
}(ForkEvent);

exports.TransactionForkEvent = TransactionForkEvent;

var TransactionOrderForkEvent = /*#__PURE__*/function (_ForkEvent3) {
  _inherits(TransactionOrderForkEvent, _ForkEvent3);

  var _super4 = _createSuper(TransactionOrderForkEvent);

  function TransactionOrderForkEvent(beforeHash, afterHash, expiry) {
    _classCallCheck(this, TransactionOrderForkEvent);

    if (!(0, _bytes.isHexString)(beforeHash, 32)) {
      logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
    }

    if (!(0, _bytes.isHexString)(afterHash, 32)) {
      logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
    }

    return _super4.call(this, {
      _isForkEvent: true,
      _isTransactionOrderForkEvent: true,
      expiry: expiry || 0,
      beforeHash: beforeHash,
      afterHash: afterHash
    });
  }

  return TransactionOrderForkEvent;
}(ForkEvent); ///////////////////////////////
// Exported Abstracts


exports.TransactionOrderForkEvent = TransactionOrderForkEvent;

var Provider = /*#__PURE__*/function () {
  function Provider() {
    _classCallCheck(this, Provider);

    logger.checkAbstract(this instanceof Provider ? this.constructor : void 0, Provider);
    (0, _properties.defineReadOnly)(this, "_isProvider", true);
  } // Alias for "on"


  _createClass(Provider, [{
    key: "addListener",
    value: function addListener(eventName, listener) {
      return this.on(eventName, listener);
    } // Alias for "off"

  }, {
    key: "removeListener",
    value: function removeListener(eventName, listener) {
      return this.off(eventName, listener);
    }
  }], [{
    key: "isProvider",
    value: function isProvider(value) {
      return !!(value && value._isProvider);
    }
  }]);

  return Provider;
}();

exports.Provider = Provider;